<template lang="html">
  <div class="activityPage">
  	<common-header></common-header>
    <activityDetail :infoData="infoData"></activityDetail>
    <common-footer></common-footer>
  </div>
</template>

<script>
	import commonHeader from '../../components/common/commonHeader'
	import commonFooter from '../../components/common/commonFooter'
	import activityDetail from'../../components/activity/activityDetail.vue'
	//接口
	import Server from '../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		infoId:'',
		  		infoData:''
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		activityDetail,
	  	},
	  	created(){
	  		this.infoId = this.$route.params.infoId;
	  		Server.infoDetail(this.infoId).then((result)=>{
	  			if(result.code == '0'){
	  				this.infoData = result.msg;
	  				this.infoData.PUB_TIME =this.infoData.PUB_TIME.slice(0,10);
					console.log(this.infoData);
	  			}
	  		})
	  	}
	}
</script>

<style lang="less" scoped>
	.activityPage{
		// padding-bottom:250px;
	}
</style>


// WEBPACK FOOTER //
// src/container/activityPage/activityDetail.vue